// En tu componente (puedes crearlo como un método estático o función separada)
import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators
{

  static atLeastOneCheckboxChecked(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formArray = control as FormArray;
      if (formArray.length === 0) {
        return null; // No mostrar error si no hay opciones
      }
      // Verificar si al menos un checkbox está en true
      const atLeastOneChecked = formArray.controls.some(
        group => group.get('answer')?.value === true
      );

      return atLeastOneChecked ? null : { atLeastOneCheckboxRequired: true };
    };
  }
}
